import React from 'react'
import { Field } from 'redux-form'
import WrappedInput from '../../Shared/Forms/WrappedInput'

export default function StripeOptions({ form }) {
  return (
    <div>
      <Field
        name="apiKey"
        component={WrappedInput}
        label="Stripe Secret Key"
        placeholder="sk_live_••••••••"
        autoComplete="off"
        type="password"
      />
      <Field
        name="name"
        component={WrappedInput}
        label="Source Nickname"
        placeholder="Stripe"
        autoComplete="off"
      />
    </div>
  )
}
